import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { InlineEditorFieldType } from 'src/app/shared/components/inline-editor/inline-editor.component';
import { SelectOption } from 'src/app/shared/interfaces/selectOption';

type EditableRecord = object;
export type TableAction = 'actions' | 'edit' | 'deleteById' | 'deleteByIndex';

@Component({
  selector: 'app-editable-records-table',
  templateUrl: './editable-records-table.component.html',
  styleUrls: ['./editable-records-table.component.scss'],
})
export class EditableRecordsTableComponent implements OnChanges, AfterViewInit {
  @Input() records: EditableRecord[] = [];
  @Input() actions: TableAction[] = [];
  @Input() displayedColumns: {
    key: string;
    label: string;
    type: InlineEditorFieldType;
    width?: string;
    options?: SelectOption[];
  }[] = [];

  @Output() recordDeletedById = new EventEmitter<{ id: number }>();
  @Output() recordDeletedByIndex = new EventEmitter<{ index: number }>();
  @Output() recordUpdated = new EventEmitter<{
    record: EditableRecord;
    key: string;
    value: string | number | boolean;
  }>();

  @ViewChild(MatSort) sort!: MatSort;

  dataSource = new MatTableDataSource<EditableRecord>([]);
  allColumns: string[] = [];

  ngOnChanges() {
    this.allColumns = this.displayedColumns.map((c) => c.key);
    if (this.actions.length > 0) {
      this.allColumns.push('actions');
    }

    this.dataSource.data = this.records;
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  onUpdate(row: EditableRecord, key: string, newValue: string | number | boolean) {
    (row as Record<string, unknown>)[key] = newValue;
    this.recordUpdated.emit({ record: row, key, value: newValue });
  }

  onDeleteById(id: number) {
    this.recordDeletedById.emit({ id });
  }

  onDeleteByIndex(index: number) {
    this.recordDeletedByIndex.emit({ index });
  }

  onSortChange(sortState: Sort) {
    console.log('Sorting changed:', sortState);
  }
}